export function batchFunction(items, operationFunction, count = 50) {
    if (!items.length) {
        return [];
    }
    const result = operationFunction(items.slice(0, count)) || [];
    return [...result, ...batchFunction(items.slice(count), operationFunction, count)];
}
